import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IPromotionBoxEventPayload {
    developerName: string;
    offerName: string;
    position: string;
    promotionCategory: string;
}

interface IPromotionBoxClickEventPayload extends IPromotionBoxEventPayload {
    clickText: string;
}

export const hitPromotionTabClick = (clickText: string) => {
    hitGoogleTagManager({
        event: "promotion_tab",
        event_action: "click",
        event_label: clickText
    });
};

export const hitPromotionBoxView = (payload: IPromotionBoxEventPayload) => {
    hitGoogleTagManager({
        event: "promotion_box",
        event_action: "view",
        event_category: payload.promotionCategory,
        event_category2: payload.developerName,
        event_category3: payload.offerName,
        event_category4: payload.position
    });
};

export const hitPromotionBoxClick = (payload: IPromotionBoxClickEventPayload) => {
    hitGoogleTagManager({
        event: "promotion_box",
        event_action: "click",
        event_label: payload.clickText,
        event_category: payload.promotionCategory,
        event_category2: payload.developerName,
        event_category3: payload.offerName,
        event_category4: payload.position
    });
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IPromotionBoxEventPayload {
    developerName: string;
    offerName: string;
    position: string;
    promotionCategory: string;
}

interface IPromotionBoxClickEventPayload extends IPromotionBoxEventPayload {
    clickText: string;
}

export const hitPromotionTabClick = (clickText: string) => {
    hitGoogleTagManager({
        event: "promotion_tab",
        event_action: "click",
        event_label: clickText
    });
};

export const hitPromotionBoxView = (payload: IPromotionBoxEventPayload) => {
    hitGoogleTagManager({
        event: "promotion_box",
        event_action: "view",
        event_category: payload.promotionCategory,
        event_category2: payload.developerName,
        event_category3: payload.offerName,
        event_category4: payload.position
    });
};

export const hitPromotionBoxClick = (payload: IPromotionBoxClickEventPayload) => {
    hitGoogleTagManager({
        event: "promotion_box",
        event_action: "click",
        event_label: payload.clickText,
        event_category: payload.promotionCategory,
        event_category2: payload.developerName,
        event_category3: payload.offerName,
        event_category4: payload.position
    });
};
